import React from 'react';
import Events from '../../../Components/event';

import { EventInterface } from '../../../Services/types';
interface ListInterface {
    events: EventInterface[]
}
const ListSection: React.FC<ListInterface> = ({events}: ListInterface) => {
    if(events.length == 0)
        return ;
    return (
        <section className='pt-4 pb-12'>
            <div className="max-w-screen-xl mx-auto px-4">
                <h2 className="text-center font-semibold text-2xl mb-10 text-balance">
                    Eventos
                </h2>

                <div className="grid md:grid-cols-2 gap-8 max-w-screen-lg mx-auto">
                    {events.map((event) => (
                        <Events key={event.id} slug={event.slug} local={event.local} title={event.titulo} type={event.tipo} date={event.data} thumbnail={event.thumbnail} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ListSection;